import { Container, Sprite } from 'pixi.js'
import { getRandomInt } from '@/scripts/utils/math'

export default class SmokeParticle {
  private sprite: Sprite
  private alpha: number
  private maxH: number
  private vX: number
  private vY: number
  private vS: number
  private vR: number

  constructor(container: Container, maxH: number, alpha: number, tint: number = 0xffffff) {
    this.maxH = -maxH
    this.alpha = alpha / 1.5

    this.vX = 0.0
    this.vY = 0.0
    this.vS = 0.0
    this.vR = 0.0

    this.sprite = Sprite.from(`p-smoke-${getRandomInt(1, 3)}.png`)
    this.sprite.anchor.x = 0.5
    this.sprite.anchor.y = 0.5
    this.sprite.tint = tint

    container.addChild(this.sprite)

    this.resetParticle()

    // set init random y
    this.sprite.y = Math.random() * this.maxH
    const posValue = -this.sprite.y / this.vY
    this.sprite.x -= this.vX * posValue
    this.sprite.scale.x += this.vS * posValue
    this.sprite.scale.y = this.sprite.scale.x
  }

  private resetParticle(): void {
    this.sprite.x = 0
    this.sprite.y = 0
    this.sprite.rotation = Math.random() * Math.PI * 2
    this.sprite.alpha = this.alpha
    this.sprite.scale.x = 0.2
    this.sprite.scale.y = 0.2
    this.vX = (-0.02 + Math.random() * 0.1) * 0.5
    this.vY = 0.09 + Math.random() * 0.09
    this.vS = (0.0007 + Math.random() * 0.0003) * 0.9
    this.vR = -0.01 + Math.random() * 0.02
  }

  public move(): void {
    this.sprite.x -= this.vX
    this.sprite.y -= this.vY
    this.sprite.rotation += this.vR
    this.sprite.alpha = this.alpha * (1 - this.sprite.y / this.maxH)

    this.sprite.scale.x += this.vS
    this.sprite.scale.y = this.sprite.scale.x

    if (this.sprite.y < this.maxH) {
      this.resetParticle()
    }
  }
}
